import React from 'react';
import { User } from 'types/user';
import UserItemModule from './UserItemModule';
import List from 'components/list/List';

type UserListModuleProps = {
  users: User[];
};

const UserListModule: React.FC<UserListModuleProps> = ({ users }) => {
  return (
    <List>
      {users.map(user => (
        <UserItemModule key={user.id} user={user} />
      ))}
    </List>
  );
};

export default UserListModule;
